export default __webpack_public_path__ + "fonts/icomoon.63c5f1bdf4605908d4b029a61e5d7ba5.woff";